
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import * as fileSaver from 'file-saver';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-issue-seller-posting-label-brief',
  templateUrl: './issue-seller-posting-label-brief.component.html',
  styleUrl: './issue-seller-posting-label-brief.component.scss'
})


export class IssueSellerPostingLabelBriefComponent  implements OnInit {
  FilteredgetSubDetailsData = [];

  labelsData = [];
  tempdata = [];
  data1 = [];
  today = new Date();
  repNames = '';
  deliveryMode = '';
  firstRepName = '';
  lastRepName = '';
  district = '';
  state = '';
  taluka = '';

  shortName = {
    वार्षिक: 'वा.',
    त्रैवार्षिक: 'त्रै.',
    पंचवार्षिक: 'पंच.',
    लोकनेता_गंथयात्री_वार्षिक: 'लो.गं.वा.',
    लोकमान्य_ग्रंथयात्री_वार्षिक_वर्गणी: 'लो.ग्रं.वा.व.',
    हिंदुत्व_ग्रंथयात्री: 'हिं.ग्रं.',
    हिंदुत्व_2: 'हिं.2.',
    रामसेवक_ग्रंथयात्री: 'रा.ग्रं.',
  };
  iscustomer: any;

  constructor(private datePipe: DatePipe,
    private dialogref: MatDialogRef<IssueSellerPostingLabelBriefComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  currentDate: Date = new Date();
  groupedData = [];
  country:any=null
  sub_type:any=null
  pincode:any=null
  office_rep_name:any=null
  rep_name:any=null
  name:any=null
  Subscription_Type:any=null
  delivery_mode:any=null

  ngOnInit(): void {
    this.FilteredgetSubDetailsData = [];
    this.labelsData = this.data['addresslabels'];
    this.repNames = this.data['rep_names'];
    this.deliveryMode = this.data['delivery_mode'];
    console.log(this.repNames);
    if (this.repNames.length > 0) {
      this.firstRepName =
        this.repNames[0] == 'all' ? this.repNames[1] : this.repNames[0];
      this.lastRepName = this.repNames[this.repNames.length - 1];
    }
    this.district = this.data['district_name'];
    this.country = this.data['country'];
    this.state = this.data['state_name'];
    this.taluka = this.data['taluka_name'];
    this.iscustomer = this.data['iscustomer'];
    this.sub_type = this.data['sub_type'];
    this.pincode = this.data['pincode'];
    this.office_rep_name = this.data['office_rep_name'];
    this.rep_name = this.data['rep_name'];
    this.name = this.data['name'];
    this.Subscription_Type = this.data['Subscription_Type'];
    this.delivery_mode = this.data['delivery_mode'];
    this.tempdata = this.uniqueid(this.labelsData, (a) => a['district']);
    // console.log(this.tempdata);

    this.sortDataDistrictwise();
    this.groupDataBySubscription();
  }

  groupDataBySubscription() {
    this.groupedData = this.data1.reduce((acc, item) => {
       
        let group = acc.find(g =>
          (!this.country || this.country.includes(g.country)) &&
          (!this.state || this.state.includes(g.state)) &&
          (!this.district || this.district.includes(g.district)) &&
          (!this.taluka || this.taluka.includes(g.taluka)) &&
          (!this.sub_type || this.taluka.includes(g.sub_type)) &&
          (!this.pincode || this.pincode.includes(g.pincode)) &&
          (!this.office_rep_name || this.office_rep_name.includes(g.office_rep_name)) &&
          (!this.rep_name || this.rep_name.includes(g.rep_name)) &&
          (!this.name || this.name.includes(g.name)) && 
          (!this.Subscription_Type || this.Subscription_Type.includes(g.Subscription_Type)) && 
          (!this.delivery_mode || this.delivery_mode.includes(g.delivery_mode))
      );
      
        if (!group) {
            group = { 
              Subscription_Type: item.Subscription_Type, 
                       subtype: item.subtype || null, 
                       country: item.country || null,
                       state: item.state || null,
                       delivery_mode: item.delivery_mode || null,
                       district: item.district,
                       taluka: item.taluka || null,
                       office_rep_name: item.office_rep_name || null, 
                       rep_name: item.rep_name || null,
                       name: item.name || null,
                       pincode: item.pincode || null,
                       items: [] };
            acc.push(group);
        }
        // group.subtype.add(item.subtype); 

        group.items.push(item);
        return acc;
    }, []);

    // this.groupedData.forEach(group => group.subtype = Array.from(group.subtype));
}

  sortDataDistrictwise() {
    this.labelsData.sort((a, b) => Number(a.pincode) - Number(b.pincode));
    // this.tempdata.sort((a, b) => a.name.localeCompare(b.name, ['en', 'mr']));
    for (let index = 0; index < Object.keys(this.tempdata).length; index++) {
      let data = this.labelsData.filter(
        (a) => a['district'] == this.tempdata[index]['district']
      );

      data.map((a) => {
        a.shortname = this.shortName[a.Subscription_Type.split(' ').join('_')];
      });

      // this.tempdata.push({ index: data });

      // data.sort((a, b) => {
      //   if (a.name < b.name) {
      //     return -1;
      //   } else if (a.name > b.name) {
      //     return 1;
      //   } else {
      //     return 0;
      //   }
      // });
     
      this.data1.push(data);
    }

   
    // console.log(this.data1);
    // console.log(this.tempdata);
    let data=[]
    this.data1.forEach(element => {
      element.forEach(data2 => {
        data.push(data2)
      });
      
    });
    this.data1=data

    if (this.data1.length <= 4) {
      const requiredLength = 5;
      const numberOfItemsToAdd = requiredLength - this.data1.length;
  
      // Push empty data to fill up the list
      for (let i = 0; i < numberOfItemsToAdd; i++) {
        this.data1.push({
          shortname: '',
          month: '',
          subno: '',
          year: '',
          title: '',
          name: '',
          address: '',
          taluka: '',
          district: '',
          pincode: '',
          state: ''
        });
      }
    }

// let currentPage=1
// let printData:any=[]
//     for (let i = 0; i < this.data1.length; i++) {
//       const item = this.data1[i];
//       if (i % 28 === 0 && i !== 0) {
//         currentPage++;
//       }
//       printData.push({ ...item, pageNumber: currentPage });
//     }
//     this.data1=printData
  }

  uniqueid(data, key) {
    return [...new Map(data.map((x) => [key(x), x])).values()];
  }
  getPageNumber(index: number): number {
    return Math.floor(index / 28) + 1;
  }
  // print() {
  //   document.title = 'Labels';
  //   window.print();
  // }

  show=false 
  printPage() {
    this.show=true
    const printContent = document.getElementById('print-section')?.outerHTML;
    if (!printContent) {
        console.error("Print section not found!");
        return;
    }

    const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');

    if (printWindow) {
        printWindow.document.open();
        printWindow.document.write(`
            <html>
                <head>
                    <title>Print Report</title>
                    <style>
                        @media print {
                            @page { 
                                size: A3 landscape; /* Set A3 size with landscape mode */
                                margin: 5mm; /* Adjust margins */
                            }
                            body { 
                                font-family: Arial, sans-serif; 
                                font-size: 16px; /* Adjust font size */
                                margin: 0; 
                                padding: 5mm; 
                                line-height: 1.2; 
                            }
                            table { 
                                width: 100%; 
                                height: 100%;
                                border-collapse: collapse; 
                                table-layout: fixed; /* Prevent column expansion */
                                page-break-inside: avoid; /* Avoid breaking the table */
                            }
                            th, td { 
                                padding: 1px; 
                                border: 1px solid black; 
                                text-align: left; 
                                font-size: 14px; /* Adjusted font size */
                                line-height: 1.2; 
                            }
                            .noPrint { 
                                display: none; /* Hide print button */
                            }
                        }
                    </style>
                </head>
                <body>
                    <div id="print-section1">
                        ${printContent}
                    </div>
                    <script>
                        window.onload = function() { 
                            window.print(); 
                            setTimeout(() => { window.close(); }, 500);
                        };
                    </script>
                </body>
            </html>
        `);
        printWindow.document.close();
    } else {
        console.error("Failed to open print window.");
    }
}

  // getRep(rep, pos) {
  //   console.log(
  //     rep.split(',')[pos === 'first' ? 0 : rep.split(',').length - 1]
  //   );

  //   return ;
  // }


    exportExcel(fileName) {
      /* table id is passed over here */
      let element = document.getElementById('print-section');
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
      /* save to file */
      XLSX.writeFile(wb, fileName + '.xlsx');
    }

    //  excelToExportPostingLabel(name) {
    //     const EXCEL_TYPE =
    //       'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    //     const EXCEL_EXTENSION = '.xlsx';
    
    //     // custom code
    //     const worksheet = XLSX.utils.json_to_sheet(this.FilteredgetSubDetailsData);
    
    //     const workbook = {
    //       Sheets: {
    //         dataSheet: worksheet,
    //       },
    //       SheetNames: ['dataSheet'],
    //     };
    
    //     const excelBuffer = XLSX.write(workbook, {
    //       bookType: 'xlsx',
    //       type: 'array',
    //     });
    
    //     const blobData = new Blob([excelBuffer], { type: EXCEL_TYPE });
    
    //     fileSaver.saveAs(blobData, name);
    //   }

    // excelToExportPostingLabel(name: string) {
    //   const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    //   const EXCEL_EXTENSION = '.xlsx';
    
    //   if (!this.data1 || this.data1.length === 0) {
    //     console.warn('No data available to export.');
    //     return;
    //   }
    
    //   // ✅ Step 1: Map only selected and existing fields
    //   const limitedData = this.data1.map(row => ({
    //     "वर्गणीदार क्रमांक": `${row.Subscription_Type || ''}/${row.month || ''}/${row.subno || ''}`,
    //     "वर्गणीदार नाव": `${row.title || ''}.${row.name || ''}`,
    //     "पत्ता": `${row.address || ''} ${row.taluka || ''} ${row.district || ''} ${row.state || ''} ${row.country || ''} ${row.pincode || ''}`,
    //     "वर्गणीदार प्रकार": row.Subscription_Type || '',
    //     "वैध दिनांक": `${row.entry_date ? this.datePipe.transform(row.entry_date, 'dd/MM/yyyy') : ''} - ${row.sub_perid_to_date ? this.datePipe.transform(row.sub_perid_to_date, 'dd/MM/yyyy') : ''}`,
    //     "संपर्क": row.mobileNumber || ''
    //   }));
    
    //   // ✅ Step 2: Create worksheet
    //   const worksheet = XLSX.utils.json_to_sheet(limitedData);
    
    //   const workbook = {
    //     Sheets: {
    //       dataSheet: worksheet,
    //     },
    //     SheetNames: ['dataSheet'],
    //   };
    
    //   // ✅ Step 3: Write and download
    //   const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    //   const blobData = new Blob([excelBuffer], { type: EXCEL_TYPE });
    
    //   fileSaver.saveAs(blobData, `${name}${EXCEL_EXTENSION}`);
    // }
    
    formatDateRange(row: any): string {
      const entryDate = row.entry_date ? this.datePipe.transform(row.entry_date, 'dd/MM/yyyy') : '';
      const subPeridToDate = row.sub_perid_to_date ? this.datePipe.transform(row.sub_perid_to_date, 'dd/MM/yyyy') : '';
      return `${entryDate} - ${subPeridToDate}`;
    }

    group: { rep_name?: string; office_rep_name?: string ; delivery_mode?: string; country?: string; 
      state?: string ; district?: string; taluka?: string ; Subscription_Type?: string} = {};

    excelToExportPostingLabel(name: string) {
      const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      const EXCEL_EXTENSION = '.xlsx';
    
      if (!this.data1 || this.data1.length === 0) {
        console.warn('No data available to export.');
        return;
      }
    
      // Step 1: Map your data with desired keys and formatted dates.
      const limitedData = this.data1.map(row => ({
        "वर्गणीदार क्रमांक": `${row.Subscription_Type || ''}/${row.month || ''}/${row.subno || ''}`,
        "वर्गणीदार नाव": `${row.title || ''}.${row.name || ''}`,
        "पत्ता": `${row.address || ''} ${row.taluka || ''} ${row.district || ''} ${row.state || ''} ${row.country || ''} ${row.pincode || ''}`,
        "वर्गणीदार प्रकार": row.Subscription_Type || '',
        "वैध दिनांक": `${row.entry_date ? this.datePipe.transform(row.entry_date, 'dd/MM/yyyy') : ''} - ${row.sub_perid_to_date ? this.datePipe.transform(row.sub_perid_to_date, 'dd/MM/yyyy') : ''}`,
        "संपर्क": row.mobileNumber || ''
      }));
    
      // Step 2: Create an initially empty worksheet.
      let worksheet = {};
    
      // Step 3: Insert your custom header groups.
      // Header Group 1 (Rows 1-2)
      const headerRows1 = [
        [`दिनांक: ${this.datePipe.transform(new Date(), 'dd/MM/yyyy')}`, 'हिंदुस्तान प्रकाशन संस्था विवेक साप्ताहिक', '', '', '', ''],
        // ['हिंदुस्तान प्रकाशन संस्था विवेक साप्ताहिक', '', '', '', '', '']
      ];
      XLSX.utils.sheet_add_aoa(worksheet, headerRows1, { origin: "A1" });
    
      // Header Group 2 (Rows 3-4)
      const headerRows2 = [
        [`पृष्ठ क्र:  `, '', 'नोंदणीदार - प्रतिनिधी व कार्यालयीन वर्गणी वर्गणी जमा असलेले', '', '', ''],
        // ['नोंदणीदार - प्रतिनिधी व कार्यालयीन वर्गणी वर्गणी जमा असलेले', '', '', '', '', '']
      ];
      
    //   const headerRows2 = [
    //     [
    //         `पृष्ठ क्र:`, '', 
    //         `नोंदणीदार - ${(this.group?.rep_name?.trim() || 'प्रतिनिधी')} - ${(this.group?.office_rep_name?.trim() || 'व कार्यालयीन')} वर्गणी जमा असलेले`, 
    //         '', '', ''
    //     ]
    // ];
    
      XLSX.utils.sheet_add_aoa(worksheet, headerRows2, { origin: "A2" });

      // const headerRows4 = [
      //   [``, '', 'वितरण - टपाल', '', '', ''],
      //   // ['नोंदणीदार - प्रतिनिधी व कार्यालयीन वर्गणी वर्गणी जमा असलेले', '', '', '', '', '']
      // ];
      // XLSX.utils.sheet_add_aoa(worksheet, headerRows4, { origin: "A3" });
    
      // Header Group 3 (Row 5-6)
      const headerRows3 = [
        [` `, 'वितरण - टपाल ', 'वर्गणी - वर्गणी जमा असलेले ', 'वितरण सांकेताकानुसार वर्गणीदार यादीर्गणीदार प्रकार ', '', '']
      ];

    //   const headerRows3 = [
    //     [
    //         `वितरण - ${(this.group?.rep_name?.trim() || '-')}`,
    //         `${this.group?.country?.trim() || '-'} - ${this.group?.state?.trim() || '-'} - ${this.group?.district?.trim() || '-'} - ${this.group?.taluka?.trim() || '-'}`,
    //         'वर्गणी - वर्गणी जमा असलेले',
    //         `वितरण सांकेताकानुसार वर्गणीदार यादीर्गणीदार प्रकार - ${(this.group?.Subscription_Type?.trim() || '-')}`,
    //         '',
    //         ''
    //     ]
    // ];
      XLSX.utils.sheet_add_aoa(worksheet, headerRows3, { origin: "A4" });
    
      // Step 4: Insert the column header row (Row 7).
      const columnHeaders = [["वर्गणीदार क्रमांक", "वर्गणीदार नाव", "पत्ता", "वर्गणीदार प्रकार", "वैध दिनांक", "संपर्क"]];
      XLSX.utils.sheet_add_aoa(worksheet, columnHeaders, { origin: "A5" });
    
      // Step 5: Append the JSON data starting from row 8.
      XLSX.utils.sheet_add_json(worksheet, limitedData, { skipHeader: true, origin: "A6" });
    
      // Step 6: Create workbook and trigger download.
      const workbook = {
        Sheets: { dataSheet: worksheet },
        SheetNames: ['dataSheet'],
      };
    
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const blobData = new Blob([excelBuffer], { type: EXCEL_TYPE });
      fileSaver.saveAs(blobData, `${name}${EXCEL_EXTENSION}`);
    }
    
    
    

}